'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrV2FileStoryCommentPreview } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-story-metadata-utils';
import { PrV2FileStoryCommentCountBadge } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-header/pr-v2-file-story-header-stats/pr-v2-file-story-comment-count-badge';
import { DiffLineStats } from '@/components/ui/diff-line-stats';
type PrV2FileStoryHeaderStatsProps = {
  filename: string;
  commentPreviews: PrV2FileStoryCommentPreview[];
  additionsCount: number;
  deletionsCount: number;
};
export function PrV2FileStoryHeaderStats(t0) {
  const $ = _c(12);
  const {
    filename,
    commentPreviews,
    additionsCount,
    deletionsCount
  } = t0;
  const t1 = `pr-v2-file-header-stats-${filename}`;
  let t2;
  if ($[0] !== commentPreviews || $[1] !== filename) {
    t2 = <PrV2FileStoryCommentCountBadge filename={filename} commentPreviews={commentPreviews} />;
    $[0] = commentPreviews;
    $[1] = filename;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `pr-v2-file-header-line-additions-${filename}`;
  const t4 = `pr-v2-file-header-line-deletions-${filename}`;
  let t5;
  if ($[3] !== additionsCount || $[4] !== deletionsCount || $[5] !== t3 || $[6] !== t4) {
    t5 = <DiffLineStats additions={additionsCount} deletions={deletionsCount} className="text-xs" additionsTestId={t3} deletionsTestId={t4} />;
    $[3] = additionsCount;
    $[4] = deletionsCount;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t5) {
    t6 = <div className="mr-2 inline-flex items-center gap-2 text-[11px] font-normal tabular-nums text-zinc-400" data-testid={t1}>{t2}{t5}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}